/**
 *
 * PluginIcon
 *
 */

import React from 'react';

import { Landscape } from '@strapi/icons';

const PluginIcon = () => <Landscape />;

export default PluginIcon;
